import type {MemexColumnDataType} from '../../../api/columns/contracts/memex-column'
import {BaseMultiSelectColumnModel} from '../abstract/base-multi-select'

export class MultiSelectColumnModel extends BaseMultiSelectColumnModel {
  declare readonly id: number
  declare readonly dataType: typeof MemexColumnDataType.MultiSelect
  declare readonly userDefined: true
}
